import { anchorBaseComponents } from './anchor-base.js'
import { anchorSingleFeetBaseComponents } from './anchor-single-feet-base.js'
import { anchorSinglePlatformBaseComponents } from './anchor-single-platform-base.js'
import { anglePictureFrameBaseComponents } from './angle-picture-frame-base.js'
import { anglePictureFrameCtcBaseComponents } from './angle-picture-frame-ctc-base.js'
import { anglePictureFrameSingleBaseComponents } from './angle-picture-frame-single-base.js'
import { apronBasicComponents } from './apron-basic.js'
import { archBaseComponents } from './arch-base.js'
import { archSingleBaseComponents } from './arch-single-base.js'
import { baseDoubleLegComponents } from './base-double-leg.js'
import { baseFourLegCombinedComponents } from './base-four-leg-combined.js'
import { baseFourLegSeparateComponents } from './base-four-leg-separate.js'
import { baseSingleLegComponents } from './base-single-leg.js'
import { baseComponents } from './base.js'
import { bellhouseBaseComponents } from './bellhouse-base.js'
import { bellhouseSingleFeetBaseComponents } from './bellhouse-single-feet-base.js'
import { bellhouseSinglePlatformBaseComponents } from './bellhouse-single-platform-base.js'
import { bellyStretchedBaseComponents } from './belly-stretched-base.js'
import { benchBasicComponents } from './bench-basic.js'
import { boatShapeTopComponents } from './boat-shape-top.js'
import { boxFrameBaseComponents } from './box-frame-base.js'
import { brewerBaseComponents } from './brewer-base.js'
import { brewerSingleBaseComponents } from './brewer-single-base.js'
import { caseyBaseComponents } from './casey-base.js'
import { connectedXBaseComponents } from './connected-x-base.js'
import { craftsmanBaseComponents } from './craftsman-base.js'
import { craftsmanSingleBaseComponents } from './craftsman-single-base.js'
import { crescentBaseComponents } from './crescent-base.js'
import { crescentSingleBaseComponents } from './crescent-single-base.js'
import { danaBaseComponents } from './dana-base.js'
import { danaSingleBaseComponents } from './dana-single-base.js'
import { dremorTurnedBaseComponents } from './dremor-turned-base.js'
import { ellipticalOvalTopComponents } from './elliptical-oval-top.js'
import { franklinBaseComponents } from './franklin-base.js'
import { franklinSingleFeetBaseComponents } from './franklin-single-feet-base.js'
import { franklinSinglePlatformBaseComponents } from './franklin-single-platform-base.js'
import { herricksonTurnedBaseComponents } from './herrickson-turned-base.js'
import { hershBaseComponents } from './hersh-base.js'
import { ivyBaseComponents } from './ivy-base.js'
import { mantisBaseComponents } from './mantis-base.js'
import { marksBaseComponents } from './marks-base.js'
import { meredithBaseComponents } from './meredith-base.js'
import { meredithSingleFeetBaseComponents } from './meredith-single-feet-base.js'
import { meredithSinglePlatformBaseComponents } from './meredith-single-platform-base.js'
import { midModernTaperBaseComponents } from './mid-modern-taper-base.js'
import { narrowEnglishTurnedBaseComponents } from './narrow-english-turned-base.js'
import { oldEnglishTurnedBaseComponents } from './old-english-turned-base.js'
import { oswaldBaseComponents } from './oswald-base.js'
import { oswaldSingleBaseComponents } from './oswald-single-base.js'
import { peruStretchedBaseComponents } from './peru-stretched-base.js'
import { racetrackOvalTopComponents } from './racetrack-oval-top.js'
import { rectangleTopComponents } from './rectangle-top.js'
import { reededBaseComponents } from './reeded-base.js'
import { reflectionBaseComponents } from './reflection-base.js'
import { reflectionCtcBaseComponents } from './reflection-ctc-base.js'
import { rishBaseComponents } from './rish-base.js'
import { rishSingleBaseComponents } from './rish-single-base.js'
import { rogersBaseComponents } from './rogers-base.js'
import { rogersSinglePlatformBaseComponents } from './rogers-single-platform-base.js'
import { rootEntityComponents } from './root-entity.js'
import { roundTopComponents } from './round-top.js'
import { singlePostBaseComponents } from './single-post-base.js'
import { singlePostSingleBaseComponents } from './single-post-single-base.js'
import { slagleTurnedBaseComponents } from './slagle-turned-base.js'
import { slimConnectedXBaseComponents } from './slim-connected-x-base.js'
import { slimConnectedXSingleBaseComponents } from './slim-connected-x-single-base.js'
import { squareTopComponents } from './square-top.js'
import { tableComponents } from './table.js'
import { tamaraBaseComponents } from './tamara-base.js'
import { tamaraSingleBaseComponents } from './tamara-single-base.js'
import { topWithDiameterComponents } from './top-with-diameter.js'
import { topWithSideComponents } from './top-with-side.js'
import { topWithWidthAndLengthComponents } from './top-with-width-and-length.js'
import { topComponents } from './top.js'
import { traditionalBaseComponents } from './traditional-base.js'
import { traditionalFlushBaseComponents } from './traditional-flush-base.js'
import { triflectionBaseComponents } from './triflection-base.js'
import { tuscanBaseComponents } from './tuscan-base.js'
import { tuscanSingleFeetBaseComponents } from './tuscan-single-feet-base.js'
import { tuscanSinglePlatformBaseComponents } from './tuscan-single-platform-base.js'
import { waldenBaseComponents } from './walden-base.js'
import { waldenSingleBaseComponents } from './walden-single-base.js'
import { xBaseComponents } from './x-base.js'
import { xMetalBaseComponents } from './x-metal-base.js'
import { xMetalSingleBaseComponents } from './x-metal-single-base.js'
import { xSingleBaseComponents } from './x-single-base.js'

export const generatedComponents = [
  ...tableComponents,
  ...topComponents,
  ...apronBasicComponents,
  ...baseDoubleLegComponents,
  ...baseFourLegCombinedComponents,
  ...baseFourLegSeparateComponents,
  ...baseSingleLegComponents,
  ...baseComponents,
  ...benchBasicComponents,
  ...rootEntityComponents,
  ...topWithDiameterComponents,
  ...topWithSideComponents,
  ...topWithWidthAndLengthComponents,
  ...anchorBaseComponents,
  ...anchorSingleFeetBaseComponents,
  ...anchorSinglePlatformBaseComponents,
  ...bellhouseBaseComponents,
  ...bellhouseSingleFeetBaseComponents,
  ...bellhouseSinglePlatformBaseComponents,
  ...bellyStretchedBaseComponents,
  ...brewerBaseComponents,
  ...brewerSingleBaseComponents,
  ...caseyBaseComponents,
  ...craftsmanBaseComponents,
  ...craftsmanSingleBaseComponents,
  ...crescentBaseComponents,
  ...crescentSingleBaseComponents,
  ...danaBaseComponents,
  ...danaSingleBaseComponents,
  ...franklinBaseComponents,
  ...franklinSingleFeetBaseComponents,
  ...franklinSinglePlatformBaseComponents,
  ...mantisBaseComponents,
  ...marksBaseComponents,
  ...meredithBaseComponents,
  ...meredithSingleFeetBaseComponents,
  ...meredithSinglePlatformBaseComponents,
  ...oswaldBaseComponents,
  ...oswaldSingleBaseComponents,
  ...peruStretchedBaseComponents,
  ...rishBaseComponents,
  ...rishSingleBaseComponents,
  ...rogersBaseComponents,
  ...rogersSinglePlatformBaseComponents,
  ...tamaraBaseComponents,
  ...tamaraSingleBaseComponents,
  ...tuscanBaseComponents,
  ...tuscanSingleFeetBaseComponents,
  ...tuscanSinglePlatformBaseComponents,
  ...waldenBaseComponents,
  ...waldenSingleBaseComponents,
  ...xBaseComponents,
  ...xSingleBaseComponents,
  ...anglePictureFrameBaseComponents,
  ...anglePictureFrameSingleBaseComponents,
  ...anglePictureFrameCtcBaseComponents,
  ...archBaseComponents,
  ...archSingleBaseComponents,
  ...boxFrameBaseComponents,
  ...connectedXBaseComponents,
  ...slimConnectedXBaseComponents,
  ...slimConnectedXSingleBaseComponents,
  ...reflectionBaseComponents,
  ...reflectionCtcBaseComponents,
  ...singlePostBaseComponents,
  ...singlePostSingleBaseComponents,
  ...xMetalBaseComponents,
  ...xMetalSingleBaseComponents,
  ...ivyBaseComponents,
  ...dremorTurnedBaseComponents,
  ...herricksonTurnedBaseComponents,
  ...midModernTaperBaseComponents,
  ...narrowEnglishTurnedBaseComponents,
  ...oldEnglishTurnedBaseComponents,
  ...slagleTurnedBaseComponents,
  ...traditionalBaseComponents,
  ...traditionalFlushBaseComponents,
  ...reededBaseComponents,
  ...hershBaseComponents,
  ...triflectionBaseComponents,
  ...rectangleTopComponents,
  ...squareTopComponents,
  ...roundTopComponents,
  ...ellipticalOvalTopComponents,
  ...racetrackOvalTopComponents,
  ...boatShapeTopComponents,
]
